import React from 'react'
import VehiclesAdmin from '../AdminComponents/VehiclesAdmin/VehiclesAdmin'

const VehiclePageAdmin = () => {
  return (
    <>
    <VehiclesAdmin/>
    
    </>
  )
}

export default VehiclePageAdmin